export default __webpack_public_path__ + "static/media/start_right.5c1ae0fd.png";